export default __webpack_public_path__ + "static/media/Deacon's Boots of the Eighteen Pits.43a46dbd.jpg";